export const SET_SPORT_META = 'SET_SPORT_META'

/**
 * Set sport meta data
 *
 * @param {Object} state
 * @param {array} sportMeta
 * @return {{sportMeta: *}}
 */
function setSportMeta(state, sportMeta) {
    return {
        ...state,
        sportMeta: sportMeta,
    }
}

/**
 * @param {Object} state
 * @param {Object} action
 * @return {*}
 */
export default function reducer(state = [], action) {
    switch (action.type) {
        case SET_SPORT_META:
            return setSportMeta(state, action.sportMeta)
        default:
            return state
    }
}
